<template>
    <div class="information-detail" id="goDesignatedSpot">
        <van-row class="detail-header">{{ tradeCaseDetail.title }}</van-row>
        <van-row class="information-detail-time">
            <van-row>{{ tradeCaseDetail.source }}</van-row>
            <van-row class="line"></van-row>
            <van-row>{{ formatDate(tradeCaseDetail.releaseDate) }}</van-row>
        </van-row>
        <van-row class="information-detail-content" v-html="tradeCaseDetail.detail"></van-row>
    </div>
</template>

<script>

import moment from "moment";
import tradeCaseService from "@/trade-case/service/trade-case-service";
import {noticeManager} from "@zhoujianhui/vip-core";

export default {
    name: "tradeCaseDetail",
    data() {
        return {
            tradeCaseDetail: {},
            tradeCaseDetailId: null
        }
    },
    created() {
        this.tradeCaseDetailId = JSON.parse(this.$route.query.tradeCaseDetailId);
        this.getTradeCaseDetail();
    },
    methods: {
        //查询贸易案例
        async getTradeCaseDetail() {
            const result = await tradeCaseService.getTradeCaseById(this.tradeCaseDetailId);
            if (result.isSuccess()) {
                this.tradeCaseDetail = result.data;
            } else {
                noticeManager.showMessage(result.msg, result.type);
            }
            this.loading = false;
        },

        gotoTop() {
            window.location.hash = "#goDesignatedSpot";
        },
        formatDate(dateTime) {
            if (dateTime) {
                return moment(dateTime).format("YYYY/MM/DD hh:mm");
            } else {
                return "-";
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.information-detail {
    padding: 18% 4%;

    :deep(img) {
        max-width: 100%;
    }

    .detail-header {
        color: #000000;
        font-weight: 600;
        font-size: 18px;
    }

    .information-detail-time {
        margin-top: 15px;
        display: flex;
        color: #999999;

        .line {
            width: 1px;
            height: 14px;
            background: #999999;
            margin: 0 10px;
        }
    }

    .information-detail-content {
        margin-top: 25px;
        font-size: 16px;
        color: #999999;
    }

    .image-size {
        margin-top: 25px;
        display: flex;
        justify-content: space-between;

        img {
            width: 45%;

        }

        & img:last-child {
            margin-right: -25px;

        }

    }

    .information-detail-question {
        margin-top: 20px;
        color: #000000;
        font-size: 18px;
        font-weight: 600;
    }

    .question-answer {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;

        .question-content {
            display: flex;
            width: 220px;

            .question-left {
                margin-right: 5px;

                > img {
                    width: 54px;
                    height: 54px;
                }
            }

            .question-right {
                display: flex;
                flex-direction: column;

                & span:first-child {
                    font-weight: 600;
                    color: #000000;
                    font-size: 14px;
                    line-height: 25px;
                }

                & span:last-child {
                    color: #999999;
                    font-size: 10px;
                }
            }


        }

        .attachment {
            background: #1890ff;
            padding: 10px 20px;
            margin-bottom: 20px;

            > img {
                margin-right: 5px;
            }

            > span {
                color: white;
                font-size: 10px;

            }
        }

    }

    .information-detail-fotter {
        font-size: 10px;
        color: #999999;
        margin-top: 10px;
    }
}
</style>